/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioTypology } from './InternalApiScenarioTypology';
import {
    InternalApiScenarioTypologyFromJSON,
    InternalApiScenarioTypologyFromJSONTyped,
    InternalApiScenarioTypologyToJSON,
    InternalApiScenarioTypologyToJSONTyped,
} from './InternalApiScenarioTypology';

/**
 * 
 * @export
 * @interface InternalApiLibraryScenarioCategory
 */
export interface InternalApiLibraryScenarioCategory {
    /**
     * 
     * @type {string}
     * @memberof InternalApiLibraryScenarioCategory
     */
    id: string;
    /**
     * Scenario category name
     * @type {string}
     * @memberof InternalApiLibraryScenarioCategory
     */
    name: string;
    /**
     * Scenario category abbreviation
     * @type {string}
     * @memberof InternalApiLibraryScenarioCategory
     */
    abbreviation: string;
    /**
     * 
     * @type {Array<InternalApiScenarioTypology>}
     * @memberof InternalApiLibraryScenarioCategory
     */
    typologies: Array<InternalApiScenarioTypology>;
}

/**
 * Check if a given object implements the InternalApiLibraryScenarioCategory interface.
 */
export function instanceOfInternalApiLibraryScenarioCategory(value: object): value is InternalApiLibraryScenarioCategory {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('abbreviation' in value) || value['abbreviation'] === undefined) return false;
    if (!('typologies' in value) || value['typologies'] === undefined) return false;
    return true;
}

export function InternalApiLibraryScenarioCategoryFromJSON(json: any): InternalApiLibraryScenarioCategory {
    return InternalApiLibraryScenarioCategoryFromJSONTyped(json, false);
}

export function InternalApiLibraryScenarioCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiLibraryScenarioCategory {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'abbreviation': json['abbreviation'],
        'typologies': ((json['typologies'] as Array<any>).map(InternalApiScenarioTypologyFromJSON)),
    };
}

export function InternalApiLibraryScenarioCategoryToJSON(json: any): InternalApiLibraryScenarioCategory {
    return InternalApiLibraryScenarioCategoryToJSONTyped(json, false);
}

export function InternalApiLibraryScenarioCategoryToJSONTyped(value?: InternalApiLibraryScenarioCategory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'abbreviation': value['abbreviation'],
        'typologies': ((value['typologies'] as Array<any>).map(InternalApiScenarioTypologyToJSON)),
    };
}

